import "core-js/modules/es.reflect.construct.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import Component from '../core/component';
import { mix } from '../core/core';
import { EmitterMixin } from '../core/eventemitter';
import ScrollTo from '../services/scrollto';
import axios from 'axios';
import gsap from 'gsap';
import Fields from './fields';
/*----------------------------------------------------*/
// Constants & variables

/*----------------------------------------------------*/

var defaults = {
  name: 'form',
  fields: 'input, textarea, select',
  ignore: '.input-gtfo',
  $: {
    endpoint: 'input[name="endpoint"]',
    form: '.form__form',
    success: '.form__success'
  },
  $$: {}
};
var properties = {
  $form: null
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Form = /*#__PURE__*/function (_mix$with) {
  _inherits(Form, _mix$with);

  var _super = _createSuper(Form);

  function Form(element) {
    var _this2;

    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);

    _classCallCheck(this, Form);

    // element
    var $element = Component.isElement(element);

    if (typeof $element === 'undefined' || !$element) {
      throw new Error('Passed element is not a valid element');
    } // options


    var opts = Object.assign(Object.create(null), defaults, options);
    _this = _super.call(this, opts); // properties

    Object.assign(_assertThisInitialized(_this), Component.cloneDeep(properties));
    _this.$element = $element; // eslint-disable-next-line prefer-rest-params

    (_this2 = _this).init.apply(_this2, arguments);

    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Form, [{
    key: "init",
    value: function init() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _get(_getPrototypeOf(Form.prototype), "init", this)).call.apply(_get2, [this].concat(args));

      this.$select(this.$element); // promises

      this.promises.sending = null; // find form element

      if (this.$element.prop('tagName') === 'FORM') {
        this.$form = this.$element;
      } else {
        this.$form = this.$element.find('form').first();
      }

      this.attach();
      this.bindEvents();
      this.emit('init');
      return this;
    } // Methods
    // --------------------------------------------------

  }, {
    key: "attach",
    value: function attach() {
      var _this3 = this;

      var $fields = this.$form.find(this.options.fields);
      $fields.each(function (i, field) {
        var $field = $d(field);

        if ($field.prop('type') !== 'hidden' && !$field.is(_this3.options.ignore)) {
          var $error = $d('<div class="form__error" />');
          var $group = Fields.getGroup(field);
          var $wrapper = $field;

          if ($group && $group.length) {
            $group.after($error);
            $wrapper = $group;
          } else {
            $field.after($error);
          }

          $field.on('invalid.form', function (e) {
            $wrapper.addClass('input--error');
            $error.text(field.validationMessage);

            _this3.emit('field:invalid', field); // reset state


            var inputHandler = function inputHandler() {
              field.oninput = null;
              $error.text('');
              $wrapper.removeClass('input--error');
              var validity = field.checkValidity();
              if (validity) _this3.emit('field:valid', field);
            };

            field.oninput = inputHandler;
          });
        }
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this4 = this;

      // bail if submission is still running to prevent multiple submission at once
      if (this.promises.sending !== null) {
        return this.promises.sending;
      } // fields data


      var fields = this.$form.serializeObject(); // disable submit buttons

      this.disableSubmits(); // XHR

      var endpoint = this.$.endpoint.val();
      var xhr = axios.post("".concat(this.app.globals.resturl, "/").concat(endpoint), fields);
      this.promises.sending = xhr;
      xhr.then(function (response) {
        // reset promise
        _this4.promises.sending = null; // re-enable submit buttons

        _this4.enableSubmits();

        if (typeof response.data.success !== 'undefined' && response.data.success === true) {
          _this4.success();
        }
      });
      return xhr;
    }
  }, {
    key: "success",
    value: function success() {
      var _this5 = this;

      if (this.$.form.length) {
        var height = this.$.form.height();
        this.$.form.height(height);
      } // remove loading spinner


      var $submits = this.$form.find('*[type="submit"]');
      $submits.removeClass('btn--loading');
      var tl = gsap.timeline({
        paused: true,
        onComplete: function onComplete() {
          _this5.emit('success');
        }
      });

      if (this.$.form.length) {
        tl.to(this.$.form, {
          height: 0,
          autoAlpha: 0,
          duration: 0.5,
          ease: 'expo.inOut'
        });
      }

      if (this.$.success.length) {
        tl.set(this.$.success, {
          display: 'block',
          autoAlpha: 0
        });
        tl.fromTo(this.$.success, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out'
        });
      }

      tl.play();
    } // Helpers
    // --------------------------------------------------

  }, {
    key: "scrollToError",
    value: function scrollToError() {
      var $fields = this.$form.find(this.options.fields);
      var firstFieldError = null;
      $fields.get().some(function (elm) {
        if ($d(elm).is(':invalid')) {
          firstFieldError = elm;
          return true;
        }

        return false;
      });

      if (firstFieldError) {
        ScrollTo(firstFieldError, 1000, -100);
      }
    }
  }, {
    key: "enableSubmits",
    value: function enableSubmits() {
      var $submits = this.$form.find('*[type="submit"]');
      $submits.removeAttr('disabled');
    }
  }, {
    key: "disableSubmits",
    value: function disableSubmits() {
      var $submits = this.$form.find('*[type="submit"]');
      $submits.attr('disabled', true).addClass('btn--loading');
    } // Events
    // --------------------------------------------------

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this6 = this;

      var _this$$form = _slicedToArray(this.$form, 1),
          form = _this$$form[0]; // disable native validation ui


      form.noValidate = true; // evaluate form on submit and prevent things if needed

      this.$form.on('submit.form', function (e) {
        var validity = form.checkValidity();

        if (!validity) {
          e.preventDefault();

          _this6.emit('invalid', e);

          _this6.scrollToError();

          _this6.enableSubmits();
        } else {
          _this6.emit('valid', e);
        }
      }); // if an endpoint is specified automate the async data sending

      if (this.$.endpoint.length) {
        this.$form.on('submit', function (e) {
          return e.preventDefault();
        });
        this.on('valid', this.submit, this);
      }
    }
  }]);

  return Form;
}(mix(Component).with(EmitterMixin));

export { Form as default };

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}